module.exports = __webpack_public_path__ + "img/thumbnail_JapaneseMacaque_j_normal.f3f79d4c.png";